import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import { bubEvents } from 'shared/events/bub_events';

export function AudiobookCreditNames({ credits, truncate, type }) {
  const trackingTerm = type[0].toUpperCase() + type.slice(1);

  function trackClick(name) {
    bubEvents.track(trackingTerm, 'Clicked link', {
      label: `${trackingTerm} name`,
      value: name,
    });
  }

  function linkName(credit) {
    return (
      <a href={credit.url} onClick={() => trackClick(credit.name)}>
        {credit.name}
      </a>
    );
  }

  if (_.isEmpty(credits)) {
    return <span>Unknown</span>;
  }

  if (credits.length === 1) {
    return <span>{linkName(credits[0])}</span>;
  }

  if (credits.length === 2) {
    return (
      <span>
        {linkName(credits[0])} & {linkName(credits[1])}
      </span>
    );
  }

  if (!truncate) {
    return (
      <span>
        {_.map(credits, (credit, idx) => (
          <span key={credit.url}>
            {idx > 0 ? ', ' : ''}
            {linkName(credit)}
          </span>
        ))}
      </span>
    );
  }

  const collectionTerm = pluralize(trackingTerm, credits.length);
  return <span>Collected {collectionTerm}</span>;
}

AudiobookCreditNames.propTypes = {
  credits: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
  truncate: PropTypes.bool,
  type: PropTypes.oneOf(['author', 'narrator']).isRequired,
};

AudiobookCreditNames.defaultProps = {
  truncate: true,
};
